export default [
  {
    position: "absolute",
    top: 57.8,
    left: 40.6,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 16,
    tooltipText: "performanceP2.ttTextNine",
    hover: false,
    id: "SP_Performance_Navigation_Performance_Objectives",
    index: 0,
  },
  {
    position: "absolute",
    top: 64,
    left: 39.8,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "performanceP2.mTitleTwo",
    mBody: "performanceP2.mBodyTwo",
    id: "SP_Performance_Info_Coaching",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 57.8,
    left: 89.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "performanceP2.ttTextSeven",
    hover: false,
    id: "SP_Performance_Navigation_CompetencyAssessment",
    index: 2,
  },
  {
    position: "absolute",
    top: 88,
    left: 17,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 14,
    tooltipText: "performanceP2.ttTextEight",
    hover: false,
    id: "SP_Performance_Navigation_Recognition",
    index: 3,
  },
  {
    position: "absolute",
    top: 0.6,
    left: 0.4,
    class: "tooltips",
    tooltipClass: "right",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "performanceP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_Performance_Navigation_Menu",
    index: 4,
  },
  {
    position: "absolute",
    top: 0.6,
    left: 23,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "performanceP2.ttTextTwo",
    hover: false,
    id: "SP_Performance_Navigation_Communications",
    index: 5,
  },
  {
    position: "absolute",
    top: 5.4,
    left: 27.7,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "performanceP2.ttTextFour",
    hover: false,
    id: "SP_Performance_Navigation_Absence",
    index: 6,
  },
  {
    position: "absolute",
    top: 4.1,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "performanceP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_Performance_Navigation_TeamMember",
    index: 7,
  },
];
